/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect } from 'react'

import { Link, useNavigate } from 'react-router-dom'

import DeliveryIcon from '../../../assets/svg/PeykProfileIcon.svg'
import PeykProfileIcon from '../../../assets/svg/PeykProfile.svg'
import PeykMenuOrder from '../../../assets/svg/PeykMenuOrder-mini.svg'
import PeykMenuAnalyticActive from '../../../assets/svg/PeykMenuAnalytic-mini.svg'
import PeykMenuMessage from '../../../assets/svg/PeykMenuMessage-mini-active.svg'
import PeykMenuOrderDone from '../../../assets/svg/PeykMenuOrderDone-mini.svg'
import PeykHat from '../../../assets/svg/PeykHat-mini.svg'
import Arrow from '../../../assets/svg/Arrow.svg'
import { post } from '../../../services/https'

export default function index() {
  const token = localStorage.getItem('token')
  
  const navigate = useNavigate()
  
  useEffect(() => {
    post('/api/front/users/verify', {
      token: localStorage.getItem('token')
      }).then(response => {
        // console.log(response)
        if (response.data.message === 'احراز هویت با موفقیت انجام شد') {

        } else {
          navigate('/peyk')
        }
    }).catch(() => {
      navigate('/peyk')
    })
  }, [navigate, token])
  
  return (
    <div id='peyk'>
      <header className='header'>
        <section className='header__name'>
          <div>
            <img src={DeliveryIcon} alt="DeliveryIcon" />
          </div>
          <div className='profileName'>
            <span className='profileName__self'>
              محمد خوشه چین
            </span>
            <span className='profileName__tag'>
              سفیر کانولی
            </span>
          </div>
        </section>
        <section className='header__profile'>
          <Link to='/#'>
            <img src={PeykProfileIcon} alt="PeykProfileIcon" />
          </Link>
        </section>
      </header>
      <main className='body analytic__page'>
        <div className="body__title">
          پیام‌ها
        </div>
        <ul className='ordersList'>
          <li className='ordersList__item'>
            <Link to='/#'>
              <span>
                محمد خوشه چین
              </span>
              <span>
                مشاهده <img src={Arrow} alt="Arrow" />
              </span>
            </Link>
          </li>
        </ul>
        <Link to='/peyk/message'>
          <div className="addmessage">
            +
          </div>
        </Link>
      </main>
      <nav className='navbar'>
        <Link to='/peyk/current' className='navbar__item'>
          <span>
            <img src={PeykMenuOrder} alt="PeykMenuOrderActive" />
          </span>
          <span>
            سفارشات
          </span>
        </Link>
        <Link to='/peyk/analytic' className='navbar__item'>
          <span>
            <img src={PeykMenuAnalyticActive} alt="PeykMenuAnalytic" />
          </span>
          <span>
            حسابداری
          </span>
        </Link>
        <Link to='/peyk/dashboard' className='navbar__item'>
          <span>
            <img src={PeykHat} alt="PeykHat" />
          </span>
          <span>
            سفیر
          </span>
        </Link>
        <Link to='/peyk/messages' className='navbar__item'>
          <span>
            <img src={PeykMenuMessage} alt="PeykMenuMessage" />
          </span>
          <span className='navbar__item--active'>
            پیام‌ها
          </span>
        </Link>
        <Link to='/peyk/orders' className='navbar__item'>
          <span>
            <img src={PeykMenuOrderDone} alt="" />
          </span>
          <span>
            انجام شده
          </span>
        </Link>
      </nav>
    </div>
  )
}
